import React from 'react';
import { TableRow, TableCell, Chip } from '@mui/material';

const STATUS_CONFIG = {
  inprogress: { label: 'In Progress', color: '#FF9800' },
  planned:    { label: 'Planned',     color: '#2196F3' },
  closed:     { label: 'Closed',      color: '#BF360C' },
  none:       { label: 'No Activity', color: '#546E7A' },
};

const fmtDate = (d) => {
  if (!d) return '—';
  return new Date(d).toLocaleDateString('en-GB', { day: '2-digit', month: 'short', year: 'numeric' });
};

const tdSx = {
  color: '#475569', fontSize: 12, borderBottom: '1px solid #F1F5F9',
  py: 0.6, px: 1.5,
};

const SiteGridRow = ({ act }) => {
  const cfg = STATUS_CONFIG[act._status] || STATUS_CONFIG.none;
  return (
    <TableRow sx={{ '&:hover': { backgroundColor: '#F8FAFC' } }}>
      <TableCell sx={tdSx}>
        <Chip label={cfg.label} size="small"
          sx={{ backgroundColor: `${cfg.color}22`, color: cfg.color,
                border: `1px solid ${cfg.color}55`, fontSize: 10, height: 20 }} />
      </TableCell>
      <TableCell sx={{ ...tdSx, maxWidth: 200, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
        {act.title || '—'}
      </TableCell>
      <TableCell sx={tdSx}>{act.feature   || '—'}</TableCell>
      <TableCell sx={tdSx}>{act.team      || '—'}</TableCell>
      <TableCell sx={tdSx}>{act.owner     || '—'}</TableCell>
      <TableCell sx={tdSx}>{fmtDate(act.startDate)}</TableCell>
      <TableCell sx={tdSx}>{fmtDate(act.endDate)}</TableCell>
    </TableRow>
  );
};

export default SiteGridRow;